export class ICDValues {
    iCDValuesId: number;
    code: string;
    usable: string;
    shortDesc: string;
    disable: boolean;
}